import { FC, ReactNode } from 'react';
import QRCode from 'react-qr-code';

import { ImageComponent } from '@/components/Image';

import { ScStepNumber, ScStepTitle } from '../styled';
import { ScQRCode } from '@/modules/profile/security/styled';

interface IStepProps {
  num: number;
  description: string;
  img?: {
    src: string;
    width?: number;
    height?: number;
  };
  qrSrc?: string;
  component?: ReactNode;
  className?: string;
}

export const Step: FC<IStepProps> = ({
  num,
  description,
  img,
  qrSrc,
  component,
  className,
}) => {
  return (
    <div className="step">
      <div>
        <ScStepNumber>
          <ImageComponent
            src={`/mobile-app/number${num + 1}.svg`}
            width={40}
            height={40}
            alt="step number"
          />
        </ScStepNumber>
        <ScStepTitle>{description}</ScStepTitle>
      </div>
      <div className="step-img">
        {img && (
          <ImageComponent
            className={className}
            src={img.src}
            width={img.width}
            height={img.height}
            alt="step image"
          />
        )}
      </div>
      {qrSrc && (
        <ScQRCode>
          <QRCode value={qrSrc} size={106} />
        </ScQRCode>
      )}
      {component}
    </div>
  );
};
